import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

import { deleteMemo, errorMessage } from './memoApi.js'

export default function MemoDeleteDialog(props) {
  const { open, onClose, token, memo } = props;

  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = () => {
    setDeleting(true);
    setError('');

    deleteMemo(token, memo.id)
      .then(() => {
        setDeleting(false);
        onClose(true);
      })
      .catch((err) => {
        setDeleting(false);
        setError(errorMessage(err));
      });
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)}>
      <DialogTitle>メモを削除しますか</DialogTitle>
      <DialogContent>
        {error &&
          <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
        }
        <DialogContentText sx={{ whiteSpace: 'pre-wrap' }}>
          {memo && memo.content.length > 100 ? memo.content.slice(0, 100) + '…' : memo && memo.content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)}>キャンセル</Button>
        <Button variant="contained" color="error" onClick={handleDelete} disabled={deleting}>
          削除
        </Button>
      </DialogActions>
    </Dialog>
  );
}

MemoDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  memo: PropTypes.object,
};
